import axios from "axios"
interface ClientUpdateInterface {
    name: string,
    short_name: string,
    tin: string,
    email: string,
    comment: string
}

// Get client-owner of workspace
function getClientOwnerFromWorkspaceApi(workspaceUuid: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/client-owner`
    })
}

// Update client profile
async function patchClientApi (uuid: string, clientUuid: string, data: ClientUpdateInterface) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}`,
        data: data
    });
}
//Create kartoteka
async function registerNewClient( uuid: string, data: any){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${uuid}/clients`,
        data
    })
}

export {
    getClientOwnerFromWorkspaceApi,
    patchClientApi,
    registerNewClient
}